export enum ApplicationMiniCartEventTypeEnum {
  DeleteIconClicked = 'Delete icon clicked',
  GoToPromotionsClicked = 'Go to promotions clicked',
  UndoClicked = 'Undo clicked',
  ProductNameClicked = 'Product name clicked',
  MiniCartView = 'mini cart view',
  removedProductLabel = 'removed product',
  removedProductAndServiceLabel = 'removed product & service',
  removedServiceLabel = 'removed service',
}
